import { AxiosInstance } from 'axios';
import { IncidentType } from '@declarations/common/enums/IncidentType';
import { RiskLevel } from '@declarations/common/enums/RiskLevel';

export type IncidentByFacilityAndType = {
  facilityId: number;
  facilityName: string;
  countsByStatus: { [S in IncidentType]?: number; };
};

export default function getIncidentsByFacilityAndType(api: AxiosInstance) {
  return (riskLevel?: RiskLevel, organizationId?: number, yearOfIncidents?: number) => api.get<IncidentByFacilityAndType[]>('/by-facility-and-type', {
    params: {risk_level: riskLevel, organization_id: organizationId, year_of_incidents: yearOfIncidents},
  });
}
